export default __webpack_public_path__ + "static/media/evernote-icon-mdl.99da6724.svg";